import React from "react";
import { FaCode, FaMobileAlt, FaPalette } from "react-icons/fa";

const services = [
  {
    icon: FaCode,
    title: "Platforma web & API",
    body: "Frontend-e të kombinuara, backend të qëndrueshëm dhe integrime që mbeten të mirëmbajtshme ndërsa rriten trafiku dhe ekipet.",
    bullets: [
      "Buxhete performance & vëzhgim",
      "CI/CD dhe hedhje në faza",
      "Dokumentacion teknik",
    ],
  },
  {
    icon: FaMobileAlt,
    title: "Aplikacione mobile",
    body: "Përvoja afër natyrale në iOS dhe Android me disiplinë hedhjeje, analitikë dhe gatishmëri për dyqanet e aplikacioneve.",
    bullets: [
      "Offline ku ka rëndësi",
      "Raportim crash-esh & miratim QA",
      "Mbështetje për App Store / Play",
    ],
  },
  {
    icon: FaPalette,
    title: "Sisteme dizajni produkti",
    body: "UX i mbështetur në kërkim, ndërfaqe dhe token-e që ekipi juaj inxhinierik i implementon pa ambiguitet.",
    bullets: [
      "Sisteme dizajni & specifikime komponentësh",
      "Modele me mendje për aksesueshmërinë",
      "Përputhje prototip → prodhim",
    ],
  },
];

function Services() {
  return (
    <section className="services section-pad" id="services">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Aftësitë</span>
          <h2>Inxhinieri dhe dizajn, në një linjë që nga dita e parë</h2>
          <p>
            Punojmë si vazhdim i organizatës suaj të produktit — komunikim
            transparent, pronësi e qartë dhe dorëzime që mund t’i auditohen,
            zgjerohen dhe kalojnë në duar të tjera.
          </p>
        </div>

        <div className="services-grid">
          {services.map(({ icon: Icon, title, body, bullets }) => (
            <article key={title} className="service-card">
              <div className="service-card-top">
                <div className="service-icon-wrap">
                  <Icon className="icon" aria-hidden="true" />
                </div>
              </div>
              <h3>{title}</h3>
              <p className="service-body">{body}</p>
              <ul className="service-bullets">
                {bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
